var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#00BF63"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7686 14.7115C18.7686 13.6494 17.5401 13.059 16.7107 13.7224L13.6885 16.1402C13.4639 16.3199 13.1849 16.4178 12.8973 16.4178H10.2666C9.56707 16.4178 9 16.9848 9 17.6843V21.6635C9 22.3631 9.56707 22.9301 10.2666 22.9301H12.8973C13.1849 22.9301 13.4639 23.028 13.6885 23.2077L16.7107 25.6255C17.5401 26.2889 18.7686 25.6985 18.7686 24.6364V14.7115Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5268 12C29.5616 14.0354 30.7046 16.7957 30.7046 19.6737C30.7046 22.5518 29.5616 25.3121 27.5268 27.3475M23.6953 15.8314C24.7127 16.8492 25.2843 18.2293 25.2843 19.6683C25.2843 21.1074 24.7127 22.4875 23.6953 23.5052",
    stroke: "white",
    strokeWidth: 1.68878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOn);
export default __webpack_public_path__ + "static/media/On.b480e48b102f1a12907b5825afd58f77.svg";
export { ForwardRef as ReactComponent };